// Cave84 — Route definitions (Phase 1 Week 6)

import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/AppShell';
import { RequireOwner } from '@/components/RequireOwner';

import DashboardPage from '@/pages/DashboardPage';
import InventoryPage from '@/pages/InventoryPage';
import AddBottlePage from '@/pages/AddBottlePage';
import BottleDetailPage from '@/pages/BottleDetailPage';
import WinesPage from '@/pages/WinesPage';
import WineAnalysisPage from '@/pages/WineAnalysisPage';
import VintageChartsPage from '@/pages/VintageChartsPage';
import WishlistPage from '@/pages/WishlistPage';
import ConsumedPage from '@/pages/ConsumedPage';
import CellarsPage from '@/pages/CellarsPage';
import SettingsPage from '@/pages/SettingsPage';
import GuestLoginLogPage from '@/pages/GuestLoginLogPage';
import SearchPage from '@/pages/SearchPage';
import ImportWizardPage from '@/pages/ImportWizardPage';
import ImportHubPage from '@/pages/ImportHubPage';
import InvoiceImportPage from '@/pages/InvoiceImportPage';
import PriceRefreshWizardPage from '@/pages/PriceRefreshWizardPage';
import PriceReviewPage from '@/pages/PriceReviewPage';
import InvestmentPage from '@/pages/InvestmentPage';
import AnalyticsPage from '@/pages/AnalyticsPage';
import SpecialOccasionsPage from '@/pages/SpecialOccasionsPage';
import DrinkSoonPage from '@/pages/DrinkSoonPage';
import NotFoundPage from '@/pages/NotFoundPage';

export const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'inventory', element: <InventoryPage /> },
      {
        path: 'inventory/add',
        element: <RequireOwner><AddBottlePage /></RequireOwner>,
      },
      { path: 'inventory/:bottleId', element: <BottleDetailPage /> },
      { path: 'wines', element: <WinesPage /> },
      { path: 'wines/:wineId', element: <WineAnalysisPage /> },
      { path: 'vintage-charts', element: <VintageChartsPage /> },
      { path: 'wishlist', element: <WishlistPage /> },
      { path: 'consumed', element: <ConsumedPage /> },
      {
        path: 'cellars',
        element: <RequireOwner><CellarsPage /></RequireOwner>,
      },
      {
        path: 'settings',
        element: <RequireOwner><SettingsPage /></RequireOwner>,
      },
      {
        path: 'settings/guest-log',
        element: <RequireOwner><GuestLoginLogPage /></RequireOwner>,
      },
      {
        path: 'settings/import',
        element: <RequireOwner><ImportWizardPage /></RequireOwner>,
      },
      // Supplier invoice imports moved out of Settings into the main Import menu.
      { path: 'settings/import/mwc', element: <Navigate to="/import/mwc" replace /> },
      {
        path: 'import',
        element: <RequireOwner><ImportHubPage /></RequireOwner>,
      },
      {
        path: 'import/:supplierId',
        element: <RequireOwner><InvoiceImportPage /></RequireOwner>,
      },
      { path: 'search', element: <SearchPage /> },
      {
        path: 'prices/refresh',
        element: <RequireOwner><PriceRefreshWizardPage /></RequireOwner>,
      },
      {
        path: 'prices/review',
        element: <RequireOwner><PriceReviewPage /></RequireOwner>,
      },
      {
        path: 'prices/investment',
        element: <RequireOwner><InvestmentPage /></RequireOwner>,
      },
      { path: 'analytics', element: <AnalyticsPage /> },
      { path: 'drink-soon', element: <DrinkSoonPage /> },
      { path: 'special-occasions', element: <SpecialOccasionsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
